module.exports = __webpack_public_path__ + "static/4e787f655644cf51898521cd0a4057e71ea4c3dce58cd4eced19ceaccbff5300-80452c0512141cf473c948a3edae287d.png";